import { Component, OnInit } from '@angular/core';
import { ToastService } from 'src/app/core/toast.service';
import { ActivatedRoute } from '@angular/router';
import { UnidadeApiService } from 'src/app/dao/api_unidade.service';
import { Unidade } from 'src/app/model/unidade';
import { PedidoService } from 'src/app/dao/pedido.service';
import { Status_DTO } from 'src/app/model/status_dto';
import { GlobalService } from 'src/app/dao/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AlertController } from '@ionic/angular';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-configuracoes-front',
  templateUrl: './configuracoes-front.page.html',
  styleUrls: ['./configuracoes-front.page.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ConfiguracoesFrontPage implements OnInit {

  title = 'Nova categoria';
  unidade: Unidade;
  status: Status_DTO[] = [];
  stts: Status_DTO;
  plano;
  fileToUpload: File = null;
  fileToUpload2: File = null;
  fileToUpload3: File = null;
  fileToUpload4: File = null;
  dominio;
  imgURL: any;
  loja;
  timeStamp;
  minTempo = '00:00';

  dataRequired = false;
  imgSRC;
  imgPath;

  imgPath2;

  etiquetaUm = Object();
  etiquetaDois = Object();
  etiquetaTres = Object();
  etiquetaQuatro = Object();

  entregAcres = Object();
  retiradAcres = Object();
  dinheiroAcres = Object();
  cartaoAcres = Object();
  cartaoCreditoAcres = Object();
  pixAcres = Object();
  mostrarHorarios = false;
  mostrarHorarios2 = false;


  json='[{"dia":0,"horaInicio":"00:00","horaFim":"00:00","nomeDia":"Domingo"},{"dia":1,"horaInicio":"00:00","horaFim":"00:00","nomeDia":"Segunda"},{"dia":2,"horaInicio":"00:00","horaFim":"00:00","nomeDia":"Terça"},{"dia":3,"horaInicio":"00:00","horaFim":"00:00","nomeDia":"Quarta"},{"dia":4,"horaInicio":"00:00","horaFim":"00:00","nomeDia":"Quinta"},{"dia":5,"horaInicio":"00:00","horaFim":"00:00","nomeDia":"Sexta"},{"dia":6,"horaInicio":"00:00","horaFim":"00:00","nomeDia":"Sábado"}]';
  listaHorarios;

  constructor(private confirmationService: ConfirmationService, public alertController: AlertController, private http: HttpClient, public global: GlobalService, private route: ActivatedRoute, private toast: ToastService, private pedidoapi: PedidoService, private apiUnidade: UnidadeApiService) { }

  ngOnInit() {

    this.dominio = this.global.dominio;
    this.loja = this.global.loja;
    this.getAllStatus();
    this.unidade = new Unidade();
    // tslint:disable-next-line: radix
    this.loadUnidade();
    this.plano = this.global.plano;
    this.pixAtivo();
    this.callImage();
    this.listaHorarios = JSON.parse(this.json);

  }

  delay(ms: number): Promise<boolean> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, ms);
    });
  }

  aplicarJson(){
    //console.log(JSON.parse(this.unidade.json_fechamento));
    //console.log(this.listaJson);
    this.unidade.json_fechamento = JSON.stringify(this.listaHorarios);
    this.toast.showSucess('Configurações de Fechamento Diário Aplicadas');
  }

  deletarJson() {
    console.log("Chamou a func");
    this.confirmationService.confirm({
      message: 'Deseja mesmo deletar as Configurações de Fechamento Diário?',
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.listaHorarios = JSON.parse(this.json);
        this.unidade.json_fechamento = "";
        this.toast.showSucess('Configurações de Fechamento Diário Limpas');
      }
    });
  }

  
  async callImage(){
    if(this.plano > 0){
    await this.delay(2000);
    this.timeStamp = (new Date()).getTime();
    
    document.getElementById('prev1').innerHTML = '<img width="100" height="100" src="'+this.dominio+"/"+this.loja+"/img/logo.png?"+this.timeStamp+'">';
    
    document.getElementById('prev2').innerHTML = '<img width="300" height="150" src="'+this.dominio+"/"+this.loja+"/img/banner-desk.png?"+this.timeStamp+'">';
    document.getElementById('prev3').innerHTML = '<img width="300" height="150" src="'+this.dominio+"/"+this.loja+"/img/banner-mobile.png?"+this.timeStamp+'">';
    document.getElementById('prev4').innerHTML = '<img width="300" height="150" src="'+this.dominio+"/"+this.loja+"/img/logobranco.png?"+this.timeStamp+'">';


    }
  }

  verStatus(ativo1, ativo2) {
  }

  showHorarios(){
    this.mostrarHorarios = this.unidade.usar_horario;
  }


  showHorarios2(){
    this.mostrarHorarios2 = this.unidade.usar_horario_local;
  }

  async loadUnidade() {
    this.unidade = await this.apiUnidade.getAtual();
    this.unidade.status_sms_notificacao = this.unidade.status_sms_notificacao.toString();
    this.unidade.tipos_entrega = this.unidade.tipos_entrega.toString();
    this.unidade.frete_fixo = this.unidade.frete_fixo.toString();
    console.log(this.unidade.frete_fixo);
    console.log(this.unidade);
    this.mostrarHorarios = this.unidade.usar_horario;
    this.mostrarHorarios2 = this.unidade.usar_horario_local


    if(this.unidade.tags === "" || this.unidade.tags === null){
      this.unidade.tags = JSON.parse('[ { "id":1, "label":"tag1", "corFonte":"#fff", "corFundo":"#000" }, { "id":2, "label":"tag2", "corFonte":"#fff", "corFundo":"#000" }, { "id":3, "label":"tag3", "corFonte":"#fff", "corFundo":"#000" }, { "id":4, "label":"tag4", "corFonte":"#fff", "corFundo":"#000" } ]');
      console.log(this.unidade.tags);
      this.etiquetaUm = this.unidade.tags[0];
      this.etiquetaDois = this.unidade.tags[1];
      this.etiquetaTres = this.unidade.tags[2];
      this.etiquetaQuatro = this.unidade.tags[3];
      console.log(this.etiquetaUm)
      console.log(this.etiquetaDois)
      console.log(this.etiquetaTres)
      console.log(this.etiquetaQuatro)
    }else{
      try{
        this.unidade.tags = JSON.parse(this.unidade.tags);
      }catch{
        this.unidade.tags = JSON.parse('[ { "id":1, "label":"tag1", "corFonte":"#fff", "corFundo":"#000" }, { "id":2, "label":"tag2", "corFonte":"#fff", "corFundo":"#000" }, { "id":3, "label":"tag3", "corFonte":"#fff", "corFundo":"#000" }, { "id":4, "label":"tag4", "corFonte":"#fff", "corFundo":"#000" } ]');
      }


      console.log(this.unidade.json_fechamento);
      try{
        this.listaHorarios = JSON.parse(this.unidade.json_fechamento);
        console.log("caiu no try");
        console.log(this.listaHorarios);
      }catch{
        this.listaHorarios = JSON.parse(this.json);
        console.log("caiu no catch");
        console.log(this.listaHorarios);
  
      }

      this.etiquetaUm = this.unidade.tags[0];
      this.etiquetaDois = this.unidade.tags[1];
      this.etiquetaTres = this.unidade.tags[2];
      this.etiquetaQuatro = this.unidade.tags[3];
      console.log(this.etiquetaUm)
      console.log(this.etiquetaDois)
      console.log(this.etiquetaTres)
      console.log(this.etiquetaQuatro)
    }
    
    


    if(this.unidade.json_acres_desc === ""){
      this.unidade.json_acres_desc = JSON.parse('[{"titulo":"entrega","desconto":0,"acres":0,"descontoPrct":0,"acresPrct":0},{"titulo":"retirada","desconto":0,"acres":0,"descontoPrct":0,"acresPrct":0},{"titulo":"cartao","desconto":0,"acres":0,"descontoPrct":0,"acresPrct":0},{"titulo":"dinheiro","desconto":0,"acres":0,"descontoPrct":0,"acresPrct":0},{"titulo":"pix","desconto":0,"acres":0,"descontoPrct":0,"acresPrct":0},{"titulo":"cartaoCredito","desconto":0,"acres":0,"descontoPrct":0,"acresPrct":0}]');
      console.log(this.unidade.json_acres_desc);
      this.entregAcres = this.unidade.json_acres_desc[0];
      this.retiradAcres = this.unidade.json_acres_desc[1];
      this.cartaoAcres = this.unidade.json_acres_desc[2];
      this.dinheiroAcres = this.unidade.json_acres_desc[3];
      this.pixAcres = this.unidade.json_acres_desc[4];
      this.cartaoCreditoAcres = this.unidade.json_acres_desc[5];
    }else{
      
      try{
        this.unidade.json_acres_desc = JSON.parse(this.unidade.json_acres_desc);
        if(this.unidade.json_acres_desc[0]['titulo'] == null || this.unidade.json_acres_desc[0]['titulo'] == undefined ){
          this.unidade.json_acres_desc[0]['titulo'] = "entrega";
          this.unidade.json_acres_desc[1]['titulo'] = "retirada";
        }
      }catch{
        this.unidade.json_acres_desc = JSON.parse('[{"titulo":"entrega","desconto":0,"acres":0,"descontoPrct":0,"acresPrct":0},{"titulo":"retirada","desconto":0,"acres":0,"descontoPrct":0,"acresPrct":0},{"titulo":"cartao","desconto":0,"acres":0,"descontoPrct":0,"acresPrct":0},{"titulo":"dinheiro","desconto":0,"acres":0,"descontoPrct":0,"acresPrct":0},{"titulo":"pix","desconto":0,"acres":0,"descontoPrct":0,"acresPrct":0},{"titulo":"cartaoCredito","desconto":0,"acres":0,"descontoPrct":0,"acresPrct":0}]');
      }
      this.entregAcres = this.unidade.json_acres_desc[0];

      this.retiradAcres = this.unidade.json_acres_desc[1];
      
      this.cartaoAcres = this.unidade.json_acres_desc[2];

      this.dinheiroAcres = this.unidade.json_acres_desc[3];

      this.pixAcres = this.unidade.json_acres_desc[4];

       if(this.unidade.json_acres_desc[5] != undefined){
        this.cartaoCreditoAcres = this.unidade.json_acres_desc[5];
       }else{
        this.cartaoCreditoAcres = JSON.parse('{"titulo":"cartaoCredito","desconto":0,"acres":0,"descontoPrct":0,"acresPrct":0}');

       }
      
      
    }




  }






  verificaTipoFrete(valor) {

  }


  zerarCampos(campo){
    console.log(campo.name);
    switch(campo.name){
      case "entregAcresdesconto":
        //this.entregAcres.desconto = 0;
        this.entregAcres.acres = 0;
        this.entregAcres.descontoPrct = 0;
        this.entregAcres.acresPrct = 0;
      break;
      case "entregAcresacres":
        this.entregAcres.desconto = 0;
        //this.entregAcres.acres = 0;
        this.entregAcres.descontoPrct = 0;
        this.entregAcres.acresPrct = 0;
      break;
      case "entregAcresdescontoPrct":
        this.entregAcres.desconto = 0;
        this.entregAcres.acres = 0;
        //this.entregAcres.descontoPrct = 0;
        this.entregAcres.acresPrct = 0;
      break;
      case "entregAcresacresPrct":
        this.entregAcres.desconto = 0;
        this.entregAcres.acres = 0;
        this.entregAcres.descontoPrct = 0;
        //this.entregAcres.acresPrct = 0;
      break;




      case "retiradAcresdesconto":
        //this.retiradAcres.desconto = 0;
        this.retiradAcres.acres = 0;
        this.retiradAcres.descontoPrct = 0;
        this.retiradAcres.acresPrct = 0;
      break;
      case "retiradAcresacres":
        this.retiradAcres.desconto = 0;
        //this.retiradAcres.acres = 0;
        this.retiradAcres.descontoPrct = 0;
        this.retiradAcres.acresPrct = 0;
      break;
      case "retiradAcresdescontoPrct":
        this.retiradAcres.desconto = 0;
        this.retiradAcres.acres = 0;
        //this.retiradAcres.descontoPrct = 0;
        this.retiradAcres.acresPrct = 0;
      break;
      case "retiradAcresacresPrct":
        this.retiradAcres.desconto = 0;
        this.retiradAcres.acres = 0;
        this.retiradAcres.descontoPrct = 0;
        //this.retiradAcres.acresPrct = 0;
      break;



      case "cartaoAcresdesconto":
        //this.cartaoAcres.desconto = 0;
        this.cartaoAcres.acres = 0;
        this.cartaoAcres.descontoPrct = 0;
        this.cartaoAcres.acresPrct = 0;
      break;
      case "cartaoAcresacres":
        this.cartaoAcres.desconto = 0;
        //this.cartaoAcres.acres = 0;
        this.cartaoAcres.descontoPrct = 0;
        this.cartaoAcres.acresPrct = 0;
      break;
      case "cartaoAcresdescontoPrct":
        this.cartaoAcres.desconto = 0;
        this.cartaoAcres.acres = 0;
        //this.cartaoAcres.descontoPrct = 0;
        this.cartaoAcres.acresPrct = 0;
      break;
      case "cartaoAcresacresPrct":
        this.cartaoAcres.desconto = 0;
        this.cartaoAcres.acres = 0;
        this.cartaoAcres.descontoPrct = 0;
        //this.cartaoAcres.acresPrct = 0;
      break;



      case "cartaoCreditoAcresdesconto":
        //this.cartaoCreditoAcres.desconto = 0;
        this.cartaoCreditoAcres.acres = 0;
        this.cartaoCreditoAcres.descontoPrct = 0;
        this.cartaoCreditoAcres.acresPrct = 0;
      break;
      case "cartaoCreditoAcresacres":
        this.cartaoCreditoAcres.desconto = 0;
        //this.cartaoCreditoAcres.acres = 0;
        this.cartaoCreditoAcres.descontoPrct = 0;
        this.cartaoCreditoAcres.acresPrct = 0;
      break;
      case "cartaoCreditoAcresdescontoPrct":
        this.cartaoCreditoAcres.desconto = 0;
        this.cartaoCreditoAcres.acres = 0;
        //this.cartaoCreditoAcres.descontoPrct = 0;
        this.cartaoCreditoAcres.acresPrct = 0;
      break;
      case "cartaoCreditoAcresacresPrct":
        this.cartaoCreditoAcres.desconto = 0;
        this.cartaoCreditoAcres.acres = 0;
        this.cartaoCreditoAcres.descontoPrct = 0;
        //this.cartaoCreditoAcres.acresPrct = 0;
      break;



      case "dinheiroAcresdesconto":
        //this.dinheiroAcres.desconto = 0;
        this.dinheiroAcres.acres = 0;
        this.dinheiroAcres.descontoPrct = 0;
        this.dinheiroAcres.acresPrct = 0;
      break;
      case "dinheiroAcresacres":
        this.dinheiroAcres.desconto = 0;
        //this.dinheiroAcres.acres = 0;
        this.dinheiroAcres.descontoPrct = 0;
        this.dinheiroAcres.acresPrct = 0;
      break;
      case "dinheiroAcresdescontoPrct":
        this.dinheiroAcres.desconto = 0;
        this.dinheiroAcres.acres = 0;
        //this.dinheiroAcres.descontoPrct = 0;
        this.dinheiroAcres.acresPrct = 0;
      break;
      case "dinheiroAcresacresPrct":
        this.dinheiroAcres.desconto = 0;
        this.dinheiroAcres.acres = 0;
        this.dinheiroAcres.descontoPrct = 0;
        //this.dinheiroAcres.acresPrct = 0;
      break;


      case "pixAcresdesconto":
        //this.pixAcres.desconto = 0;
        this.pixAcres.acres = 0;
        this.pixAcres.descontoPrct = 0;
        this.pixAcres.acresPrct = 0;
      break;
      case "pixAcresacres":
        this.pixAcres.desconto = 0;
        //this.pixAcres.acres = 0;
        this.pixAcres.descontoPrct = 0;
        this.pixAcres.acresPrct = 0;
      break;
      case "pixAcresdescontoPrct":
        this.pixAcres.desconto = 0;
        this.pixAcres.acres = 0;
        //this.pixAcres.descontoPrct = 0;
        this.pixAcres.acresPrct = 0;
      break;
      case "pixAcresacresPrct":
        this.pixAcres.desconto = 0;
        this.pixAcres.acres = 0;
        this.pixAcres.descontoPrct = 0;
        //this.pixAcres.acresPrct = 0;
      break;
    }
  }



  async getAllStatus() {
    await this.pedidoapi.getTodosStatus().then(res => {
      this.status = res;
      console.log(res);
      //this.toast.showSucess('Fretes obtidos com sucesso!');
    }).catch(async err => {
      console.log('err', err);
      //this.toast.showError('Erro ao obter Fretes');
    });
  }


  pixAtivo() {
    //Lembrar de liberar a função
    if (this.unidade.ativo_pix) {
      document.getElementById('chavepix').setAttribute("required", "");  
      //document.getElementById('divchavepix').style.display = "none";

    } else {
      document.getElementById('chavepix').removeAttribute("required");
      //document.getElementById('divchavepix').style.display = "none";

    }
  }

  setFreteGratis(valor) {
    this.dataRequired = valor;
  }

  async setHoraMinima(data) {

  }

  setHoraMinimaTeste(data) {

  }

  async confirmar1(files: FileList) {
    const alert = await this.alertController.create({
      header: 'Confirmar?',
      message: 'Tem certeza de que seu banner está nos padrões necessários de tamanho e peso de arquivo?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: 'Sim',
          handler: () => {
            this.postMethod(files)
          }
        }
      ]
    });

    await alert.present();
  }



  async confirmar2(files: FileList) {
    const alert = await this.alertController.create({
      header: 'Confirmar?',
      message: 'Tem certeza de que seu banner está nos padrões necessários de tamanho e peso de arquivo?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: 'Sim',
          handler: () => {
            this.postMethod2(files)
          }
        }
      ]
    });

    await alert.present();
  }




  async confirmar3(files: FileList) {
    const alert = await this.alertController.create({
      header: 'Confirmar?',
      message: 'Tem certeza de que seu banner está nos padrões necessários de tamanho e peso de arquivo?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: 'Sim',
          handler: () => {
            this.postMethod3(files)
          }
        }
      ]
    });

    await alert.present();
  }


  async confirmar4(files: FileList) {
    const alert = await this.alertController.create({
      header: 'Confirmar?',
      message: 'Tem certeza de que sua imagem está nos padrões necessários?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: 'Sim',
          handler: () => {
            this.postMethod4(files)
          }
        }
      ]
    });

    await alert.present();
  }


  postMethod(files: FileList) {
    this.fileToUpload = files.item(0);
    // tslint:disable-next-line: prefer-const
    let formData = new FormData();
    formData.append('file', this.fileToUpload, this.fileToUpload.name);
    let headers = new HttpHeaders();
    const auth = btoa(this.global.user + ':' + this.global.pass);
    headers = headers.set('Authorization', 'Basic ' + auth);
    // tslint:disable-next-line: max-line-length
    this.http.post(this.dominio + '/backend/api/v2/cadastro/upBannerWeb', formData, { headers }).subscribe((val) => {
      this.imgPath = val;
      //this.produto.img = this.imgPath;
    });
    this.callImage();
    return false;
  }



  postMethod2(files: FileList) {
    this.fileToUpload2 = files.item(0);
    // tslint:disable-next-line: prefer-const
    let formData = new FormData();
    formData.append('file', this.fileToUpload2, this.fileToUpload2.name);
    let headers = new HttpHeaders();
    const auth = btoa(this.global.user + ':' + this.global.pass);
    headers = headers.set('Authorization', 'Basic ' + auth);
    // tslint:disable-next-line: max-line-length
    this.http.post(this.dominio + '/backend/api/v2/cadastro/upBannerMob', formData, { headers }).subscribe((val) => {
      this.imgPath = val;
      //this.produto.img = this.imgPath;
    });
    this.callImage();
    return false;
  }



  async postMethod3(files: FileList) {
    this.fileToUpload3 = files.item(0);
    // tslint:disable-next-line: prefer-const
    let formData = new FormData();
    formData.append('file', this.fileToUpload3, this.fileToUpload3.name);
    let headers = new HttpHeaders();
    const auth = btoa(this.global.user + ':' + this.global.pass);
    headers = headers.set('Authorization', 'Basic ' + auth);
    // tslint:disable-next-line: max-line-length
    await this.http.post(this.dominio + '/backend/api/v2/cadastro/upFavicon', formData, { headers }).subscribe((val) => {
      this.imgPath = val;
      //this.produto.img = this.imgPath;
    });
    this.callImage();
    return false;
  }


  async postMethod4(files: FileList) {
    this.fileToUpload4 = files.item(0);
    // tslint:disable-next-line: prefer-const
    let formData = new FormData();
    formData.append('file', this.fileToUpload4, this.fileToUpload4.name);
    let headers = new HttpHeaders();
    const auth = btoa(this.global.user + ':' + this.global.pass);
    headers = headers.set('Authorization', 'Basic ' + auth);
    // tslint:disable-next-line: max-line-length
    await this.http.post(this.dominio + '/backend/api/v2/cadastro/upRodape', formData, { headers }).subscribe((val) => {
      this.imgPath = val;
      //this.produto.img = this.imgPath;
    });
    this.callImage();
    return false;
  }


  colocarHash(text: string){
    console.log(text);
    if(!text.includes("#")){
      console.log("#"+text);
      return "#"+text;
    }else{
      console.log(text);
      return text;
    }
  }

  async onSubmit() {

    let json = [];
    json[0] = this.entregAcres;
    json[1] = this.retiradAcres;
    json[2] = this.cartaoAcres;
    json[3] = this.dinheiroAcres;
    json[4] = this.pixAcres;
    json[5] = this.cartaoCreditoAcres;
    this.unidade.json_acres_desc = JSON.stringify(json);


    
    this.etiquetaUm.corFonte = this.colocarHash(this.etiquetaUm.corFonte);
    this.etiquetaUm.corFonte = this.colocarHash(this.etiquetaUm.corFonte);

    this.etiquetaDois.corFonte = this.colocarHash(this.etiquetaDois.corFonte);
    this.etiquetaDois.corFonte = this.colocarHash(this.etiquetaDois.corFonte);

    this.etiquetaTres.corFonte = this.colocarHash(this.etiquetaTres.corFonte);
    this.etiquetaTres.corFonte = this.colocarHash(this.etiquetaTres.corFonte);

    this.etiquetaQuatro.corFonte = this.colocarHash(this.etiquetaQuatro.corFonte);
    this.etiquetaQuatro.corFonte = this.colocarHash(this.etiquetaQuatro.corFonte);
    


    


    let json2 = [];
    json2[0] = this.etiquetaUm;
    json2[1] = this.etiquetaDois;
    json2[2] = this.etiquetaTres;
    json2[3] = this.etiquetaQuatro;
    this.unidade.tags = JSON.stringify(json2);



    //this.global.impressao_tamanho = this.unidade.impressao_tamanho;
    localStorage.setItem('impressao_tamanho', this.unidade.impressao_tamanho)
    //this.global.impressao_tipo = this.unidade.impressao_tipo;
    localStorage.setItem('impressao_tipo', this.unidade.impressao_tipo)

    // this.unidade.frete_gratis_fim = new Date(this.unidade.frete_gratis_fim).toLocaleString();
    // this.unidade.frete_gratis_inicio = new Date(this.unidade.frete_gratis_inicio).toLocaleString();
    // Lembrar de retirara a limpepza da CHAVE PIX!!!!!!!!!!
    if (this.unidade.label_comanda_mesa) {
      //this.global.comandaMesa = 'Comanda';
      localStorage.setItem('comandaMesa', 'Comanda')
    } else {
      //this.global.comandaMesa = 'Mesa';
      localStorage.setItem('comandaMesa', 'Mesa')

    }

    if (this.unidade.impressao_tamanho) {
      //this.global.impressao_tamanho = '1';
      localStorage.setItem('impressao_tamanho', '1')
    } else {
      //this.global.impressao_tamanho = '0';
      localStorage.setItem('impressao_tamanho', '0')
    }

    this.apiUnidade.alterarLabelComandaMesa(this.unidade.label_comanda_mesa);

    this.apiUnidade.alterarImpressao(this.unidade.impressao_tamanho, this.unidade.impressao_tipo);

    //this.unidade.chave_pix = '';
    // tslint:disable-next-line: radix
    if (parseInt(this.unidade.frete_gratis_inicio) >= parseInt(this.unidade.frete_gratis_fim)) {
      this.toast.showError('A data de início do frete grátis deve ser menor do que a do fim!');
    } else {

      for (var key in this.unidade) {
        if(this.unidade[key] === false){
          this.unidade[key] = 0;
        }
        if(this.unidade[key] === true){
          this.unidade[key] = 1;
        }
    }


    if(this.unidade.frame_mapa != null || this.unidade.frame_mapa != ""){
      if (this.unidade.frame_mapa.includes("script")) {
        this.unidade.frame_mapa = "";
    }
    }
      
      try {
        console.log(this.unidade);
        const result = await this.apiUnidade.atualizar(this.unidade);
        console.log(result);
        this.unidade.id = result.id;


        // tslint:disable-next-line: prefer-for-of
        for (let index = 0; index < this.status.length; index++) {
          const element = this.status[index];
          if (element.ativo_editado === true && element.ativo_original === false) {
            const resultado = await this.pedidoapi.inserirStatus(element.id)
          } else if (element.ativo_editado === false && element.ativo_original === true) {
            const resultado = await this.pedidoapi.excluirStatus(element.id)
          }
        }

        this.toast.showSucess('Salvo com sucesso');
      } catch (error) {
        console.log(error);
        this.toast.showError('Ocorreu um erro ao tentar salvar as Configurações');
      }

    }
  }
  
}